import { createRef } from 'react';

export const navigationRef = createRef<HTMLDivElement>();
